var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#FAC446"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9696 8.83398H15.0296C11.583 8.83398 11.3171 11.9323 13.178 13.619L22.8213 22.3823C24.6821 24.069 24.4163 27.1673 20.9696 27.1673H15.0296C11.583 27.1673 11.3171 24.069 13.178 22.3823L22.8213 13.619C24.6821 11.9323 24.4163 8.83398 20.9696 8.83398Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeYellow);
export default __webpack_public_path__ + "static/media/time-yellow.cc82535f7d230ebf45d977c7b36c3fe4.svg";
export { ForwardRef as ReactComponent };